var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.859375 20.9297C0.859375 9.88969 9.81938 0.929688 20.8594 0.929688C31.8994 0.929688 40.8594 9.88969 40.8594 20.9297C40.8594 31.9697 31.8994 40.9297 20.8594 40.9297C9.81938 40.9297 0.859375 31.9697 0.859375 20.9297ZM6.85938 20.9297L16.8594 30.9297L34.8594 12.9297L32.0394 10.0897L16.8594 25.2697L9.67937 18.1097L6.85938 20.9297Z",
    fill: "#7DD4EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/check_mark.162ec64cef0b595556c745d0304a7fda.svg";
export { ForwardRef as ReactComponent };